function handleSpace(e, options) {
  e.preventDefault();
  if (options.open) {
    options.actions.selectFocusedOption();
    options.actions.closeDropdown();
  } else {
    options.actions.openDropdown();
  }
}
function handleEnter(e, options) {
  if (options.open) {
    e.preventDefault();
    options.actions.selectFocusedOption();
    options.actions.closeDropdown();
  }
}
function handleEscape(e, options) {
  if (options.open) {
    options.actions.closeDropdown();
  }
}
function handleVerticalArrow(e, options) {
  e.preventDefault();
  if (options.open) {
    const delta = e.nativeEvent.key === 'ArrowUp' ? -1 : 1;
    options.actions.moveFocus(delta);
  } else {
    options.actions.openDropdown();
  }
}
function handleTab(e, options) {
  if (options.open) {
    e.preventDefault();
    options.actions.closeDropdown();
  }
}
export function processSelectKeyboardEvent(e, options) {
  switch (e.nativeEvent.key) {
    case ' ':
      return handleSpace(e, options);
    case 'Tab':
      return handleTab(e, options);
    case 'Enter':
      return handleEnter(e, options);
    case 'Escape':
      return handleEscape(e, options);
    case 'ArrowUp':
    case 'ArrowDown':
      return handleVerticalArrow(e, options);
  }
}